const buttonConfigs = [
    {
      buttonClass: "wizzy-three-products-per-row",
      bodyClass: "wizzy-three-products-per-row",
      tileViewLevel: "2"
    }, 
    {
      buttonClass: "wizzy-single-products-per-row",
      bodyClass: "wizzy-single-products-per-row",
      tileViewLevel: "1"
    }
];

const colorMap = new Map([
  ["Multi-coloured", ["https://i.ibb.co/BVjj74X/classic-color-spectrum-rgb-line-gradient-vector-522680-173-copy.png", !0]],
  ["Abstract Floral Print", ["#e5e5e5", !1]], // print stays placeholder
  ["Acai Purple", ["#6f42c1", !1]],
  ["Aqua", ["#00ffff", !1]],
  ["Aqua Mint", ["#7fffd4", !1]],
  ["Arcade", ["#0a0527", !1]],
  ["Aster Blue", ["#4666ff", !1]],
  ["Azalea Pink", ["#f7a1c4", !1]],
  ["B/W Checks", ["#000000", !1]],
  ["B/W Motif Print", ["#000000", !1]],
  ["Beige", ["#f5f5dc", !1]],
  ["Beige and Black", ["#f5f5dc", !1]],
  ["Berry Purple", ["#800080", !1]],
  ["Black", ["#000000", !1]],
  ["Black & White", ["#000000", !1]],
  ["Black and Blue", ["#0000ff", !1]],
  ["Black and Gold", ["#ffd700", !1]],
  ["Black and Grey", ["#808080", !1]],
  ["Black and Multi-coloured", ["#000000", !1]],
  ["Black and Red", ["#7c0000", !1]],
  ["Black and White", ["#808080", !1]],
  ["Blue", ["#1d5caa", !1]],
  ["Blue and Gold", ["#002db0", !1]],
  ["Brown", ["#804020", !1]],
  ["Charcoal", ["#36454f", !1]],
  ["Copper", ["#b87333", !1]],
  ["Denim", ["#1560bd", !1]],
  ["Emerald Green", ["#50c878", !1]],
  ["French Blue", ["#0072bb", !1]],
  ["Gold", ["#d4af37", !1]],
  ["Gold And Green", ["#ffd700", !1]],
  ["Gold And Pink", ["#ffc87c", !1]],
  ["Gold And Red", ["#e9967a", !1]],
  ["Gold And Yellow", ["#ffdf00", !1]],
  ["Green", ["#008000", !1]],
  ["Grey", ["#808080", !1]],
  ["Ice Blue", ["#99ffff", !1]],
  ["Indigo", ["#4b0082", !1]],
  ["Ivory", ["#f5ecda", !1]],
  ["Jade Green", ["#00a86b", !1]],
  ["Lavender", ["#e6e6fa", !1]],
  ["Light Pink", ["#ffb6c1", !1]],
  ["Mustard Yellow", ["#ffdb58", !1]],
  ["Navy Blue", ["#000080", !1]],
  ["Off-White", ["#faf9f6", !1]],
  ["Olive Green", ["#808000", !1]],
  ["Orange", ["#e5990e", !1]],
  ["Peach", ["#ffe5b4", !1]],
  ["Pink", ["#e79fab", !1]],
  ["Purple", ["#800080", !1]],
  ["Red", ["#d13b38", !1]],
  ["Rust Orange", ["#c45508", !1]],
  ["Seashell", ["#fff5ee", !1]],
  ["Silver", ["#c0c0c0", !1]],
  ["Sky Blue", ["#87ceeb", !1]],
  ["Teal Blue", ["#008080", !1]],
  ["Watermelon Sorbet", ["#fc6c85", !1]],
  ["White", ["#ffffff", !1]],
  ["White and Blue", ["#d8deec", !1]],
  ["White and Red", ["#f87c7c", !1]],
  ["Yellow", ["#ffff00", !1]],
  ["Cool Blue", ["#4997D0", !1]],
  ["Sulphur Lime", ["#d6ff00", !1]],
["Dutch Blue", ["#3d73a4", !1]],
["Lemon and Grey", ["#fde910", !1]],
["Dark Brown", ["#654321", !1]],
["Powder Blue", ["#b0e0e6", !1]],
["Smokey Grey", ["#738276", !1]],
["Off-White and Blue", ["#1d5caa", !1]],
  ["Off-White and Brown", ["#8b4513", !1]],
  ["Off-White and Light Blue", ["#add8e6", !1]],
  ["Summer Sand", ["#E8D8B5", !1]],
  ["Matcha Green", ["#7CB342", !1]],
  ["Cosmic Blue", ["#2A4B7C", !1]],
  ["Olive Brown", ["#6B6A3C", !1]],
  ["Mauve",["#f3ccc2",!1]],
  ["Turquoise Blue",["#40E0D0",!1]],
  ["Sea Green",["#2E8B57",!1]],
]);


function findHaxCode(key) {
  return colorMap.has(key) ? colorMap.get(key) : [key, !1];
}

window.onWizzyScriptLoaded = function() {

    // Force redirect mode on pages where in-page replacement can't work
    // (e.g. /pages/kp-account — Kwikpass hijacks pushState and redirects back)
    var forceRedirect = window.location.pathname.indexOf("/pages/kp-account") !== -1 ||
                        window.location.pathname.indexOf("/account") !== -1;
    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        if (forceRedirect) {
            wizzyConfig.search.configs.general.formSubmissionBehaviour = "redirect_page";
        }
        return data;
    });
        
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
        data.filters.configs.layout = "v1";
        data.search.configs.facets.leftFacets.mobileCollapsible = true;
        data.filters.configs.keepOpenedInMobileAfterApply = true;
        if (forceRedirect) {
            wizzyConfig.search.configs.general.formSubmissionBehaviour = "redirect_page";
        }
        return data;
    });
            
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(products) {
        products.forEach((product) => {
            try {
                product.attributes.forEach((attr) => {
                    if(attr.id === "product_handle") {
                        product.productHandle = attr.values[0].value[0];
                    }
                    if(attr.id === "product_variant_prices")
                    {
                        if(!product.inStock)
                        {
                            let values = attr.values;
                            values.forEach((val) => {
                                if(val.inStock)
                                {
                                    product.inStock = true;
                                }
                            })
                        }
                    }
                    else if(attr.id === "product_badge_judgeme") {
                        let divElement = document.createElement("div");
                        divElement.innerHTML = attr.values[0].value[0];
                        // console.log(divElement);
                        product.isOnCategory = window.wizzyConfig.common.isOnCategoryPage;
                        var jdgmPrevBadge = divElement.querySelector(".jdgm-prev-badge");
                        var numberOfReviews = jdgmPrevBadge.getAttribute(
                            "data-number-of-reviews"
                        );
                        var review = jdgmPrevBadge.getAttribute("data-average-rating");
                        if (numberOfReviews > 0) {
                            product.numberOfReviews = numberOfReviews;
                            product.reviewAvailable = true;
                        } else {
                            product.reviewAvailable = false;
                        }
                        product.reviewData = attr.values[0].value[0];
                        product.avgRatings = parseFloat(parseFloat(review).toFixed(1));

                        product.reviewData = function () {
                            return function (text, render) {
                            return render(attr.values[0].value[0]);
                            };
                        };
                    }
                    else if(attr.id === "product_product_category_custom") {
                        product.hasBadge = true;
                        product.badgeValue = attr.values[0].value[0];
                    }
                    const price = Math.round(Number(String(product.price).replace(/,/g, "")));
                    const sellingPrice = Math.round(Number(String(product.sellingPrice).replace(/,/g, "")));
                    product.price = price;
                    product.sellingPrice = sellingPrice;
                    if (price > sellingPrice) {
                        product.hasDiscount = true;
                    }
                })
            } catch (error) {
                console.log("Errr : ",error)   ;
            }
        })
        return products;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(data) {
        const mHeader = document.querySelector('m-header.m-header');
        if(mHeader) {
            mHeader.setAttribute("data-transparent","false");
        }
        const mHeaderWrapper = document.querySelector('m-header.m-header .m-header__wrapper');
        if(mHeaderWrapper) {
            mHeaderWrapper.classList.remove("transparent-on-top");
        }
        buttonConfigs.forEach(function (config) {
            var button = null;

            if (window.innerWidth > 768) {
                button = document.querySelector(
                    ".wizzy-tile-view-desktop-only button.tile-view-btn." + config.buttonClass
                );
            } else {
                button = document.querySelector(
                    ".wizzy-tile-view-mobile-only button.tile-view-btn." + config.buttonClass
                );
            }

            var searchWrapper = document.querySelector(".wizzy-search-wrapper");

            if (button && searchWrapper) {
                button.addEventListener("click", function () {
                    // Remove existing layout classes
                    document.body.classList.remove(
                        "wizzy-three-products-per-row",
                        "wizzy-single-products-per-row"
                    );

                    // Add selected layout class
                    document.body.classList.add(config.bodyClass);

                    // Set tile view level
                    searchWrapper.setAttribute(
                        "wizzy-tile-view-level",
                        config.tileViewLevel
                    );

                    // Reset active state
                    document.querySelectorAll("button.tile-view-btn").forEach(function (btn) {
                        btn.classList.remove("is-active");
                    });

                    // Mark current button active
                    button.classList.add("is-active");

                    try {
                    var wizzyStore = JSON.parse(localStorage.getItem("wizzy_store")) || {};

                    wizzyStore.PRODUCTS_PER_ROW = config.tileViewLevel * 2;

                    localStorage.setItem("wizzy_store", JSON.stringify(wizzyStore));
                    } catch (e) {
                        console.error("Failed to update wizzy_store in localStorage", e);
                    }
                });
            }
        });

        let sortCloseButton = document.querySelector(".wizzy-sort-close-btn");
        if(sortCloseButton) {
            sortCloseButton.addEventListener("click", function(e) {
                let commonOverlay = document.querySelector(".wizzy-common-select-selector");
                if(commonOverlay) commonOverlay.click();
            });
        }

        syncActiveTileView();
        initWizzyQuickProductTypeFilters();
        positionWizzySortHeaderAbove();
        return data;
    });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(data) {
        const mHeader = document.querySelector('m-header.m-header');
        if(mHeader) {
            mHeader.setAttribute("data-transparent","false");
        }
        const mHeaderWrapper = document.querySelector('m-header.m-header .m-header__wrapper');
        if(mHeaderWrapper) {
            mHeaderWrapper.classList.remove("transparent-on-top");
        }
        buttonConfigs.forEach(function (config) {
            var button = null;

            if (window.innerWidth > 768) {
                button = document.querySelector(
                    ".wizzy-tile-view-desktop-only button.tile-view-btn." + config.buttonClass
                );
            } else {
                button = document.querySelector(
                    ".wizzy-tile-view-mobile-only button.tile-view-btn." + config.buttonClass
                );
            }

            var searchWrapper = document.querySelector(".wizzy-search-wrapper");

            if (button && searchWrapper) {
                button.addEventListener("click", function () {
                    // Remove existing layout classes
                    document.body.classList.remove(
                        "wizzy-three-products-per-row",
                        "wizzy-single-products-per-row"
                    );

                    // Add selected layout class
                    document.body.classList.add(config.bodyClass);

                    // Set tile view level
                    searchWrapper.setAttribute(
                        "wizzy-tile-view-level",
                        config.tileViewLevel
                    );

                    // Reset active state
                    document.querySelectorAll("button.tile-view-btn").forEach(function (btn) {
                        btn.classList.remove("is-active");
                    });

                    // Mark current button active
                    button.classList.add("is-active");

                    try {
                    var wizzyStore = JSON.parse(localStorage.getItem("wizzy_store")) || {};

                    wizzyStore.PRODUCTS_PER_ROW = config.tileViewLevel * 2;

                    localStorage.setItem("wizzy_store", JSON.stringify(wizzyStore));
                    } catch (e) {
                        console.error("Failed to update wizzy_store in localStorage", e);
                    }
                });
            }
        });

        let sortCloseButton = document.querySelector(".wizzy-sort-close-btn");
        if(sortCloseButton) {
            sortCloseButton.addEventListener("click", function(e) {
                let commonOverlay = document.querySelector(".wizzy-common-select-selector");
                if(commonOverlay) commonOverlay.click();
            });
        }
        
        syncActiveTileView();
        initWizzyQuickProductTypeFilters();
        positionWizzySortHeaderAbove();
        document.body.classList.add('wizzy-search-results-rendered');
        return data;
    });
    
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(data) {
        // console.log(data);
        // data.includeOutOfStock = "true";
        var autoCompleteWrapper = document.querySelector(".m-search-popup");
        if(autoCompleteWrapper) autoCompleteWrapper.click();
        
        let collectionHeader = document.querySelector(".m-collection-page-header");
        if(collectionHeader) collectionHeader.style.display = "none";

        let collectionList = document.querySelector(".m-section.m-collection-list.m-collection-list--grid");
        if(collectionList) collectionList.style.display = "none";

        let collectionBanner = document.querySelector(".m-section.collection-banner");
        if(collectionBanner) collectionBanner.style.display = "none";

        let collectionBreadcrumbs = document.querySelector("nav.m-breadcrumb");
        if(collectionBreadcrumbs) collectionBreadcrumbs.style.display = "none";

        let collectionBrandsList = document.querySelector(".m-section.m-brands-list");
        if(collectionBrandsList) collectionBrandsList.style.display = "none";

        const alreadyExists1 = data?.sort?.some(
            (s) => s.field === "sellingPrice" && s.order === "asc"
        );
        if (!alreadyExists1 && data?.sort[0].field === "relevance") {
            data?.sort?.push({ field: "sellingPrice", order: "asc", isForParent: !1 });
        }
        // data.showOOSProductsInOrder = true;

        let wizzySearchbar = document.querySelector(".form-field.form-field--input.wizzy-search-input");
        if(wizzySearchbar) {
            wizzySearchbar.value = "";
        }

        return data;
    }, 3
);

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function(data) {
        let sortMobileHeader = document.querySelector(".wizzy-common-select-options.wizzy-sort-header");
        if(sortMobileHeader) sortMobileHeader.style.display = "none";
        const alreadyExists1 = data?.filters?.sort?.some(
            (s) => s.field === "sellingPrice" && s.order === "asc"
        );
        if (!alreadyExists1 && data?.filters?.sort[0].field === "relevance") {
            data?.filters?.sort?.push({ field: "sellingPrice", order: "asc", isForParent: !1 });
        }
        // data.filters.showOOSProductsInOrder = "true";
        return data;
    },3
);

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
        setTimeout(syncAutocompleteWidth, 2);
        // console.log("BEFORE_AUTOCOMPLETE_RENDER", data);
        const alreadyExists1 = data?.payload?.products?.filters?.sort?.some(
            (s) => s.field === "sellingPrice" && s.order === "asc"
        );
        if (!alreadyExists1 && data?.payload?.products?.filters?.sort[0].field === "relevance") {
            data?.payload?.products?.filters?.sort?.push({ field: "sellingPrice", order: "asc", isForParent: !1 });
        }
        // console.log("BEFORE_AUTOCOMPLETE_RENDER 1", data);
        return data;
    }, 3)

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED, function(data) {
        // console.log(data);
        let sort = [
            {
                field: "relevance",
                order: "asc"
            },
            {
                field: "sellingPrice",
                isForParent: false,
                order: "asc"
            },
        ];
        // let sortString = JSON.stringify(sort);
        data.sort = sort;
        return data;
    })

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(payload) {
    // console.log("before render results 1");
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        // console.log(facets);
        if(facets)
        {
          // console.log("inside facets condition");
          facets.forEach((facet) => {
            if(facet.key === "product_color_mo__custom")
            {
              // console.log("inside colors");
              facet.data.forEach((item) => {
                // console.log("inside loop");
                // console.log(item.key);
                let color = findHaxCode(item.key) || ["#e5e5e5", !1];
                // console.log(color);
                // console.log("inside loop 1");
                (item.isSwatch = !0),
                  (item.isURLSwatch = color[1]),
                  (item.isVisualSwatch = !0),
                  (item.swatchValue = color[0]),
                  (item.data = {
                    value: item.key,
                    swatch: {
                      type: "visual",
                      value: color[0],
                    },
                  });
              });
            }
          });
        }
        // console.log(payload);
      }
      // console.log("before render results 2");
        return payload;
    })
    
}

function syncActiveTileView() {
    var searchWrapper = document.querySelector(".wizzy-search-wrapper");
    var currentTileViewLevel = null;

    if (searchWrapper) {
        currentTileViewLevel = searchWrapper.getAttribute("wizzy-tile-view-level");
    }

    if (!currentTileViewLevel) {
        try {
            var wizzyStore = JSON.parse(localStorage.getItem("wizzy_store")) || {};
            if (wizzyStore.PRODUCTS_PER_ROW) {
                currentTileViewLevel = wizzyStore.PRODUCTS_PER_ROW / 2;
            }
        } catch (e) {}
    }

    if (!currentTileViewLevel) {
        if (document.body.classList.contains("wizzy-three-products-per-row")) {
            currentTileViewLevel = 3;
        } else if (document.body.classList.contains("wizzy-single-products-per-row")) {
            currentTileViewLevel = 1;
        }
    }

    document.querySelectorAll("button.tile-view-btn").forEach(function (btn) {
        btn.classList.remove("is-active");
    });

    buttonConfigs.forEach(function (config) {
        if (String(config.tileViewLevel) === String(currentTileViewLevel)) {
            var selector =
                window.innerWidth > 768
                    ? ".wizzy-tile-view-desktop-only button.tile-view-btn." + config.buttonClass
                    : ".wizzy-tile-view-mobile-only button.tile-view-btn." + config.buttonClass;

            var button = document.querySelector(selector);
            if (button) {
                button.classList.add("is-active");
            }
        }
    });
}

function syncAutocompleteWidth() {
  const searchBar = document.querySelector('#m-form-search .form-field.form-field--input');
  const autoComplete = document.querySelector('.wizzy-autocomplete-wrapper');

  if (searchBar && autoComplete) {
    const rect = searchBar.getBoundingClientRect();
    const width = searchBar.offsetWidth + 'px';
    const left = rect.left + 'px';
    
    document.documentElement.style.setProperty('--wizzy-autocomplete-width', width);
    document.documentElement.style.setProperty('--wizzy-autocomplete-left', left);
  }
}

document.body.addEventListener("click", function (event) {
    const target = event.target;
    if (target.matches(".field.has-recommendation")) {
      setTimeout(syncAutocompleteWidth, 100);      
    }
});
window.addEventListener('load', syncAutocompleteWidth);
window.addEventListener('resize', syncAutocompleteWidth);

function initWizzyQuickProductTypeFilters() {
    const summaryWrapper = document.querySelector('.wizzy-search-summary-wrapper');
    if (!summaryWrapper) return;

    const oldWrapper = document.querySelector('.wizzy-quick-filters-wrapper');
    oldWrapper && oldWrapper.remove();

    const facetBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-filters-facet-block[data-key='product_top_collection_sorting_custom']"
    );
    if (!facetBlock) return;

    const facetItems = facetBlock.querySelectorAll(
        '.wizzy-facet-list .facet-item-label-value'
    );
    if (!facetItems || facetItems.length <= 1) return;

    const selectedItems = document.querySelectorAll('.wizzy-selected-facet-list li');
    const selectedMap = {};

    selectedItems.forEach(li => {
        const key = li.getAttribute('data-facetkey');
        const value = li.getAttribute('title')?.trim();
        if (!key || !value) return;

        if (!selectedMap[key]) selectedMap[key] = [];
        selectedMap[key].push(value);
    });

    const selectedProductTypes = selectedMap['product_top_collection_sorting_custom'] || [];

    const quickWrapper = document.createElement('div');
    quickWrapper.className = 'wizzy-quick-filters-wrapper';

    facetItems.forEach((facetItem) => {
        const label = facetItem.textContent.trim();
        if (!label) return;

        const quickItem = document.createElement('div');
        quickItem.className = 'wizzy-quick-filter-item';
        quickItem.textContent = label;

        if (selectedProductTypes.includes(label)) {
        quickItem.classList.add('selected');
        }

        quickItem.addEventListener('click', () => {
        quickWrapper
            .querySelectorAll('.wizzy-quick-filter-item')
            .forEach(el => el.classList.remove('selected'));

        quickItem.classList.add('selected');
        facetItem.click();
        });

        quickWrapper.appendChild(quickItem);
    });

    summaryWrapper.insertAdjacentElement('afterend', quickWrapper);
}

function positionWizzySortHeaderAbove() {
    const sortHeader = document.querySelector(
        '.wizzy-common-select-options.wizzy-sort-header'
    );

    const optionsContainer = document.querySelector(
        '.wizzy-common-select-options:not(.wizzy-sort-header)'
    );

    if (!sortHeader || !optionsContainer) return;

    // If options are hidden, delay calculation
    if (optionsContainer.offsetHeight === 0) {
        requestAnimationFrame(positionWizzySortHeaderAbove);
        return;
    }

    const optionsRect = optionsContainer.getBoundingClientRect();

    // Guard against invalid values
    if (!optionsRect.top || optionsRect.top <= 0) return;

    const headerHeight = sortHeader.offsetHeight || 0;

    // Header is fixed, so we use viewport coords
    sortHeader.style.bottom = '';
    sortHeader.style.top = ((optionsRect.top - headerHeight) +1) + 'px';
}

document.addEventListener('click', function (e) {
  const target = e.target.closest('m-search-popup[data-open-search-popup]');
  if (!target) return;

  var searchInput = document.querySelector('#m-form-search .form-field.form-field--input[type="search"]');

  if (searchInput) {
      setTimeout(() => {
        searchInput.click();
        searchInput.focus();
    }, 360);
  }
});

